import { Box, Divider } from '@wix/design-system';
import { useAtomValue } from 'jotai';
import React from 'react';
import { activeTabIdAtom } from '../../atoms/session-atoms';
import { ACCESSIBILITY_WIZARD_TAB_IDS } from '../../consts';
import { WizardFooterDetectedIssues } from './wizard-footer-detected-issues/wizard-footer-detected-issues';
import { WizardFooterManualTasks } from './wizard-footer-manual-tasks';
import { WizardFooterStatement } from './wizard-footer-statement/wizard-footer-statement';
import { WizardFooterWelcome } from './wizard-footer-welcome/wizard-footer-welcome';
export const WizardFooter = _ref => {
  let {
    isEmptyState,
    wasDomOrderCompleted,
    hasSavePermission,
    isPublishedBranch
  } = _ref;
  const currentTabId = useAtomValue(activeTabIdAtom);
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    direction: "vertical",
    width: "100%"
  }, isEmptyState ? /*#__PURE__*/React.createElement(WizardFooterWelcome, {
    hasSavePermission: hasSavePermission,
    isPublishedBranch: isPublishedBranch,
    wasDomOrderCompleted: wasDomOrderCompleted
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP3"
  }, currentTabId === ACCESSIBILITY_WIZARD_TAB_IDS.DETECTED_TASKS && /*#__PURE__*/React.createElement(WizardFooterDetectedIssues, null), currentTabId === ACCESSIBILITY_WIZARD_TAB_IDS.MANUAL_TASKS && /*#__PURE__*/React.createElement(WizardFooterManualTasks, null)), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "D75",
    direction: "vertical",
    padding: "SP1",
    width: "100%"
  }, /*#__PURE__*/React.createElement(WizardFooterStatement, null)))));
};
//# sourceMappingURL=wizard-footer.js.map